import * as types from "../../../actions/actionTypes";

const sumObj = {
  payment: 0,
  receive: 0,
  remain: 0
};
const initialData = {
  data: {
    data: []
  },
  page_sum: sumObj,
  total_sum: sumObj,
  remain_sum: sumObj,
  use_remain: false,
  contacts: []
};
const initialState = {
  loading: true,
  error: "",
  data: initialData
};

const PettyCashierContactDetailReport = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        data: action.pageNumber ? state.data : initialData,
        error: ""
      };
    case types.PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_SUCCESS:
      return { ...state, loading: false, data: action.payLoad };
    case types.PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_REQUEST:
      return { ...state, processing: true };
    case types.PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_SUCCESS:
      return { ...state, data: action.payLoad, processing: false };
    case types.PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_FAILURE:
      return { ...state, processing: false };

    default:
      return state;
  }
};

export default PettyCashierContactDetailReport;
